export const scrollToSelectedSection = () => {
  setTimeout(() => {
    const sections = document.querySelectorAll('.timelineSection[data-index]');
    // @ts-ignore
    for (const section of sections) {
      if (!section.querySelector('.section.selected')) continue;

      const index = Number(section.getAttribute('data-index'));

      if (index >= 2) {
        section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        break;
      }
    }
  }, 1500);
};
